import { useQuery } from '@tanstack/react-query';
import api from '../../http';

interface UseGetBindingUserByIdParams {
	bindingType: number;
	bindingUserId?: string | null;
	enabled?: boolean;
}

export const useGetBindingUserById = <T = unknown>({
	bindingType,
	bindingUserId,
	enabled = true,
}: UseGetBindingUserByIdParams) => {
	return useQuery<T | null>({
		queryKey: ['binding-user', bindingType, bindingUserId],
		enabled: !!bindingUserId && enabled,
		queryFn: async () => {
			const { data } = await api.get<T>(
				`/binding-user/findOne/${bindingType}/${bindingUserId}`
			);
			return data ?? null;
		},
	});
};
